export default "__VITE_ASSET__cQpfkvfP__"